import { Badge } from "@package/subframe/components/Badge";
import {
  FeatherAlertCircle,
  FeatherCheck,
  FeatherPaperclip,
  FeatherX,
} from "@subframe/core";

import type { StatusPill, StatusPillIcon } from "@/lib/workspace/status-pill";

const PILL_ICONS: Record<StatusPillIcon, React.ReactNode> = {
  check: <FeatherCheck />,
  x: <FeatherX />,
  alert: <FeatherAlertCircle />,
  paperclip: <FeatherPaperclip />,
};

/** Renders a Workspace row's traffic-light status pill (NAU-316). */
export function WorkspaceStatusBadge({ pill }: { pill: StatusPill }) {
  return (
    <Badge
      variant={pill.tone}
      icon={pill.icon ? PILL_ICONS[pill.icon] : undefined}
    >
      {pill.label}
    </Badge>
  );
}
